import React from 'react';
import { Select } from 'antd';
import { ArrowLeft, Clock } from 'lucide-react';
import { SaveIndicatorStatus } from '../data/types';
import { DAYS_META } from '../data/questionsData';

interface QuizHeaderProps {
  day: number;
  title: string;
  currentPos: number;
  totalCount: number;
  progressPercent: number;
  savingStatus: SaveIndicatorStatus;
  lastSavedTime: string | null;
  dayStatuses: Record<number, string>;
  daysList?: { day: number; title?: string }[];
  onSelectDay: (day: number) => void;
  onExit: () => void;
}

export const QuizHeader: React.FC<QuizHeaderProps> = ({
  day,
  title,
  currentPos,
  totalCount,
  progressPercent,
  savingStatus,
  lastSavedTime,
  dayStatuses,
  daysList,
  onSelectDay,
  onExit,
}) => {
  const formatTime = (iso: string | null) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    } catch {
      return '';
    }
  };

  const getSaveLabel = () => {
    if (savingStatus === 'LOCKED') return 'Đã khóa';
    if (savingStatus === 'SAVING') return 'Đang lưu…';
    if (lastSavedTime) return `Đã lưu · ${formatTime(lastSavedTime)}`;
    return 'Tự động lưu';
  };

  return (
    <header className="fc-header">
      <div className="fc-header-main">
        <button type="button" className="fc-exit-btn" onClick={onExit} title="Quay lại">
          <ArrowLeft size={15} />
          <span>Thoát</span>
        </button>

        <div className="fc-title-group">
          <div className="fc-brand-sub">
            <span className="fc-diamond" />
            <span>ĐÁNH GIÁ NĂNG LỰC</span>
          </div>
          <div className="fc-day-title">
            Ngày {day} <span className="fc-day-subtitle">· {title}</span>
          </div>
        </div>

        {/* Day switch Select */}
        <Select
          className="fc-day-select"
          value={day}
          onChange={(val) => onSelectDay(Number(val))}
          style={{ width: 110 }}
          options={(daysList || DAYS_META).map((meta) => {
            const st = dayStatuses[meta.day] || 'LOCKED';
            const isLocked = st === 'LOCKED';
            return {
              value: meta.day,
              label: `Ngày ${meta.day}`,
              disabled: isLocked,
            };
          })}
        />

        <div className="fc-status-group">
          <div className={`fc-save-indicator ${savingStatus.toLowerCase()}`}>
            <Clock size={13} />
            <span>{getSaveLabel()}</span>
          </div>

          <div className="fc-counter-badge">
            Câu {currentPos} / {totalCount}
          </div>
        </div>
      </div>

      <div className="fc-progress-track">
        <div
          className="fc-progress-fill"
          style={{ width: `${Math.min(100, Math.max(0, progressPercent))}%` }}
        />
      </div>
    </header>
  );
};
